import { AxiosPromise } from 'axios';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import TypesEventForm from 'system/components/types-event/form';
import { typesEventCrumbs } from '../constants';
import { transformRequestTypeEvent } from '../utils/transform-type-event-request';

const TypesEventNewPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/tipievento');
  };

  const insertTypeEvent = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/tipoEvento`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback((formValues) => {
    const data = transformRequestTypeEvent(formValues);
    (
      insertTypeEvent({
        data,
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/tipievento');
    });
  }, []);
  return (
    <>
      <Breadcrumbs items={[...typesEventCrumbs, { name: 'Nuovo Tipo/Evento' }]} />
      <TypesEventForm onOk={onSubmit} title="Aggiungi  un nuovo tipo evento" onCancel={onCancel} />
    </>
  );
};

TypesEventNewPage.displayName = 'Types event new page';
export default TypesEventNewPage;
